import createIcon from "components/elements/Icons/create-icon";

export default createIcon(
  "TrashCanLight",
  [
    [
      "path",
      {
        d: "M7.7 1.85L6.98 3l7.05 0L13.3 1.85c-0.14-0.22-0.38-0.35-0.64-0.35l-4.34 0c-0.26 0-0.5 0.13-0.64 0.35zM14.6 1.1L15.79 3 18 3l1.5 0 0.75 0c0.41 0 0.75 0.34 0.75 0.75s-0.34 0.75-0.75 0.75l-0.75 0 0 15.75c0 2.07-1.68 3.75-3.75 3.75l-10.5 0c-2.07 0-3.75-1.68-3.75-3.75L0.75 4.5 0 4.5C-0.41 4.5-0.75 4.16-0.75 3.75s0.34-0.75 0.75-0.75l0.75 0 1.5 0 2.2 0L6.42 1.1C6.83 0.4 7.73 0 8.59 0l4.34 0c0.78 0 1.5 0.4 1.91 1.1zM3 4.5l0 15.75c0 1.24 1.01 2.25 2.25 2.25l10.5 0c1.24 0 2.25-1.01 2.25-2.25l0-15.75L3 4.5zm3.75 3.75l0 10.5c0 0.41-0.34 0.75-0.75 0.75s-0.75-0.34-0.75-0.75l0-10.5c0-0.41 0.34-0.75 0.75-0.75s0.75 0.34 0.75 0.75zm4.5 0l0 10.5c0 0.41-0.34 0.75-0.75 0.75s-0.75-0.34-0.75-0.75l0-10.5c0-0.41 0.34-0.75 0.75-0.75s0.75 0.34 0.75 0.75zm4.5 0l0 10.5c0 0.41-0.34 0.75-0.75 0.75s-0.75-0.34-0.75-0.75l0-10.5c0-0.41 0.34-0.75 0.75-0.75s0.75 0.34 0.75 0.75z",
      },
    ],
  ],
  "currentColor"
);
